import React from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

import "./Auth.scoped.scss"
import { PublicLayout } from "layouts/Public"
import { FormActivateAccount } from "./Partials"
import { useSubdomain } from "hooks/useSubdomain"

export const ActivateAccountPage = () => {
    const { t } = useTranslation()
    const { search } = useLocation()
    const { currentSubdomain } = useSubdomain()
    
    return (
        <PublicLayout className="login-page">
            <div className={"blur"}></div>
            
            <div className="l-form-width--l py-4 mx-auto py-7 md:py-7">
                <h1 className="c-h1 font-semibold text-center text-white">
                {t("activate_account_title", { ns: "auth" })}
                </h1>
            </div>

            <div className="mb-7">
                <div className="l-form-width mx-auto mb-12">
                    <p className="mb-5 text-white text-center">{t("update_account.description", { ns: "user" })} {currentSubdomain?.name} {t("update_account.description_next", { ns: "user" })}</p>
                </div>

                <div className="c-card p-5 md:p-12 l-form-width mx-auto">
                    <FormActivateAccount accountSlug={search.replace("?token=", "")} />
                </div>
            </div>
        </PublicLayout>
    )
}
